<template>
  <div class="comp-super-kline">
    <div class="kline-loading" v-show="isLoading"></div>
    <div id="tv_chart_container"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import $ from "jQuery";

export default {
  name: "v-super-kline",
  data() {
    return {
      isLoading: true,
      timeType: "60",
      widget: null,
      timer: null,
    };
  },
  props: {
    symbol: {
      type: String,
      default: "rwa_usdt",
    },
    height: {
      default: 451,
    },
    price_precision: {
      default: 4,
    },
    coin_precision: {
      default: 8,
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },

  mounted() {
    const this_vue = this;
    let appLocale = 'zh';
    if (this.appLan === 'en-us') {
      appLocale = 'en'
    } else if (this.appLan === 'zh-hk') {
      appLocale = 'zh'
    }  else {
      appLocale = 'zh'
    } 
    let url = "/api/v1/trade/spot/kline";
    this_vue.feed = this_vue.createFeed(url, 10000);
    let config = {
      // autosize: false,
      // fullscreen: true,
      width: "100%", //宽度
      height: "100%",
      symbol: this_vue.symbol,
      interval: this_vue.timeType,
      timezone: "Asia/Shanghai",
      toolbar_bg: "#fff",
      container_id: "tv_chart_container",
      datafeed: this_vue.feed,
      pricescale: this_vue.price_precision,
      library_path: "/static/custom_scripts/chart_main/",
      custom_css_url: "/static/custom_scripts/chart_main/static/chart.css",
      locale: appLocale,
      debug: false,
      drawings_access: {
        type: "black",
        tools: [
          { name: "Trend Line", grayed: true },
          { name: "Trend Angle", grayed: true },
        ], //todo: bb
      },
      disabled_features: [
        "hide_left_toolbar_by_default",
        "border_around_the_chart",
        // "header_settings",
        // "header_indicators",//指标
        "header_resolutions",
        // "timeframes_toolbar",
        "header_symbol_search",
        "header_chart_type",
        "header_compare",
        "header_undo_redo",
        "header_screenshot",
        "header_saveload",
        "use_localstorage_for_settings",
        "volume_force_overlay",
      ],
      enabled_features: [
        "move_logo_to_main_pane",
        "side_toolbar_in_fullscreen_mode",
        "keep_left_toolbar_visible_on_small_screens",
        "hide_last_na_study_output",
      ],
      supported_resolutions: ["1", "5", "15", "30", "60", "1D", "1W", "1M"],
      charts_storage_url: "http://saveload.tradingview.com",
      charts_storage_api_version: "1.1",
      client_id: "tradingview.com",
      user_id: "public_user_id",
    //   overrides: {
    //     "paneProperties.background": "#1C2131",
    //     "paneProperties.vertGridProperties.color": "#262B3F",
    //     "paneProperties.horzGridProperties.color": "#262B3F",
    //     //"scalesProperties.textColor" : "#AAA",
    //     "mainSeriesProperties.candleStyle.drawBorder": true,
    //     "scalesProperties.textColor": "#61688A",
    //     "mainSeriesProperties.candleStyle.upColor": "#3EC197",
    //     "mainSeriesProperties.candleStyle.downColor": "#F04C66",
    //     "mainSeriesProperties.candleStyle.wickUpColor": "#3EC197",
    //     "mainSeriesProperties.candleStyle.wickDownColor": "#F04C66",
    //     // "paneProperties.legendProperties.showLegend": false,
    //     "mainSeriesProperties.areaStyle.color1": "rgba(71, 78, 112, 0.5)",
    //     "mainSeriesProperties.areaStyle.color2": "rgba(71, 78, 112, 0.5)",
    //     "mainSeriesProperties.areaStyle.linecolor": "#9194a4",
    //     "scalesProperties.backgroundColor": "#272B41",
    //   },
      time_frames: [
        {
          text: "1min",
          resolution: "1",
          description: "realtime",
          // title: this_vue.$t("exchange.realtime")
        },
        { text: "1min", resolution: "1", description: "1min" },
        { text: "5min", resolution: "5", description: "5min" },
        { text: "15min", resolution: "15", description: "15min" },
        { text: "30min", resolution: "30", description: "30min" },
        {
          text: "1hour",
          resolution: "60",
          description: "1hour",
          title: "1hour",
        },
        /*{ text: "4hour", resolution: "240", description: "4hour",title: "4hour" },*/
        {
          text: "1day",
          resolution: "1D",
          description: "1day",
          title: "1day",
        },
        {
          text: "1week",
          resolution: "1W",
          description: "1week",
          title: "1week",
        },
        { text: "1mon", resolution: "1M", description: "1mon" },
      ],
    };
    new TradingView.widget(config).onChartReady(function () {
      this_vue.widget = this;
      let widget = this;
      // widget.chart().executeActionById("drawingToolbarAction");//一开始隐藏工具栏
      this.chart().createStudy("Moving Average", false, false, [5], null, {
        "Plot.color": "#692d87",
        "Plot.linewidth": 1,
      });
      this.chart().createStudy("Moving Average", false, false, [10], null, {
        "Plot.color": "#386c87",
        "Plot.linewidth": 1,
      });
      this.chart().createStudy("Moving Average", false, false, [30], null, {
        "Plot.color": "#878787",
        "Plot.linewidth": 1,
      });
      this.chart().createStudy("Moving Average", false, false, [60], null, {
        "Plot.color": "rgb(183, 36, 138)",
        "Plot.linewidth": 1,
      });
      //生成时间按钮color:
      // widget
      //     .createButton()
      //     .attr("title", "realtime")
      //     .on("click", function() {
      //         if ($(this).hasClass("selected")) return;
      //         $(this)
      //             .addClass("selected")
      //             .parent(".group")
      //             .siblings(".group")
      //             .find(".button.selected")
      //             .removeClass("selected");
      //         widget.chart().setChartType(3);
      //         this_vue.timeType = "1"
      //         widget.setSymbol("", "1");
      //     })
      //     .append("<span>分时</span>");
      widget
        .createButton()
        .attr("title", "M1")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "1";
          widget.setSymbol(this_vue.symbol, "1");
        })
        .append(`<span>${this_vue.$t('commonTime.minute1')}</span>`);

      widget
        .createButton()
        .attr("title", "M5")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "5";
          widget.setSymbol(this_vue.symbol, "5");
        })
        .append(`<span>${this_vue.$t('commonTime.minute5')}</span>`);

      widget
        .createButton()
        .attr("title", "M15")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "15";
          widget.setSymbol(this_vue.symbol, "15");
        })
        .append(`<span>${this_vue.$t('commonTime.minute15')}</span>`);

      widget
        .createButton()
        .attr("title", "M30")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "30";
          widget.setSymbol(this_vue.symbol, "30");
        })
        .append(`<span>${this_vue.$t('commonTime.minute30')}</span>`);

      widget
        .createButton()
        .attr("title", "H1")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "60";
          widget.setSymbol(this_vue.symbol, "60");
        })
        .append(`<span>${this_vue.$t('commonTime.hour1')}</span>`)
		.addClass("selected");

      widget
        .createButton()
        .attr("title", "H2")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "120";
          widget.setSymbol(this_vue.symbol, "120");
        })
        .append(`<span>${this_vue.$t('commonTime.hour2')}</span>`);

      widget
        .createButton()
        .attr("title", "H4")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "240";
          widget.setSymbol(this_vue.symbol, "240");
        })
        .append(`<span>${this_vue.$t('commonTime.hour4')}</span>`);

      widget
        .createButton()
        .attr("title", "D1")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "D";
          widget.setSymbol(this_vue.symbol, "D");
        })
        .append(`<span>${this_vue.$t('commonTime.day1')}</span>`);

      widget
        .createButton()
        .attr("title", "W1")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "W";
          widget.setSymbol(this_vue.symbol, "W");
        })
        .append(`<span>${this_vue.$t('commonTime.week1')}</span>`);

      widget
        .createButton()
        .attr("title", "M1")
        .on("click", function () {
          if ($(this).hasClass("selected")) return;
          $(this)
            .addClass("selected")
            .parent(".group")
            .siblings(".group")
            .find(".button.selected")
            .removeClass("selected");
          widget.chart().setChartType(1);
          this_vue.timeType = "M";
          widget.setSymbol(this_vue.symbol, "M");
        })
        .append(`<span>${this_vue.$t('commonTime.month1')}</span>`);
      this_vue.isLoading = false;
    });
  },
  methods: {
    createFeed: function (datafeedURL, updateFrequency) {
      let this_vue = this;
      let Datafeed = {};
      let _lastTime = null;
      let _lastRange = null;
      let _lastClose = null;

      Datafeed.DataPulseUpdater = function (datafeed, updateFrequency) {
        this._datafeed = datafeed;
        this._subscribers = {};

        this._requestsPending = 0;
        let that = this;

        let update = function () {
          if (that._requestsPending > 0) {
            return;
          }

          for (let listenerGUID in that._subscribers) {
            let subscriptionRecord = that._subscribers[listenerGUID];
            let resolution = subscriptionRecord.resolution;

            let datesRangeRight = parseInt(new Date().valueOf() / 1000);

            //  BEWARE: please note we really need 2 bars, not the only last one
            //  see the explanation below. `10` is the `large enough` value to work around holidays
            let datesRangeLeft =
              datesRangeRight - that.periodLengthSeconds(resolution, 5);

            that._requestsPending++;

            (function (_subscriptionRecord) {
              // eslint-disable-line
              that._datafeed.getBars(
                _subscriptionRecord.symbolInfo,
                resolution,
                datesRangeLeft,
                datesRangeRight,
                function (bars) {
                  that._requestsPending--;

                  //  means the subscription was cancelled while waiting for data
                  if (!that._subscribers.hasOwnProperty(listenerGUID)) {
                    return;
                  }

                  if (bars.length === 0) {
                    return;
                  }

                  let lastBar = bars[bars.length - 1];
                  if (
                    !isNaN(_subscriptionRecord.lastBarTime) &&
                    lastBar.time < _subscriptionRecord.lastBarTime
                  ) {
                    return;
                  }

                  let subscribers = _subscriptionRecord.listeners;

                  //  BEWARE: this one isn't working when first update comes and this update makes a new bar. In this case
                  //  _subscriptionRecord.lastBarTime = NaN
                  let isNewBar =
                    !isNaN(_subscriptionRecord.lastBarTime) &&
                    lastBar.time > _subscriptionRecord.lastBarTime;

                  //  Pulse updating may miss some trades data (ie, if pulse period = 10 secods and new bar is started 5 seconds later after the last update, the
                  //  old bar's last 5 seconds trades will be lost). Thus, at fist we should broadcast old bar updates when it's ready.
                  if (isNewBar) {
                    if (bars.length < 2) {
                      throw new Error(
                        "Not enough bars in history for proper pulse update. Need at least 2.",
                      );
                    }

                    let previousBar = bars[bars.length - 2];
                    for (let i = 0; i < subscribers.length; ++i) {
                      subscribers[i](previousBar);
                    }
                  }

                  _subscriptionRecord.lastBarTime = lastBar.time;

                  for (let i = 0; i < subscribers.length; ++i) {
                    subscribers[i](lastBar);
                  }
                },

                //  on error
                function () {
                  that._requestsPending--;
                },
              );
            })(subscriptionRecord);
          }
        };

        if (typeof updateFrequency != "undefined" && updateFrequency > 0) {
          this_vue.timer = setInterval(update, updateFrequency);
        }
      };

      Datafeed.DataPulseUpdater.prototype.periodLengthSeconds = function (
        resolution,
        requiredPeriodsCount,
      ) {
        let daysCount = 0;
        if (resolution === "D") {
          daysCount = requiredPeriodsCount;
        } else if (resolution === "M") {
          daysCount = 31 * requiredPeriodsCount;
        } else if (resolution === "W") {
          daysCount = 7 * requiredPeriodsCount;
        } else {
          daysCount = (requiredPeriodsCount * resolution) / (24 * 60);
        }

        return daysCount * 24 * 60 * 60;
      };

      Datafeed.DataPulseUpdater.prototype.subscribeDataListener = function (
        symbolInfo,
        resolution,
        newDataCallback,
        listenerGUID,
      ) {
        this._datafeed._logMessage("Subscribing " + listenerGUID);
        if (!this._subscribers.hasOwnProperty(listenerGUID)) {
          this._subscribers[listenerGUID] = {
            symbolInfo: symbolInfo,
            resolution: resolution,
            lastBarTime: NaN,
            listeners: [],
          };
        }

        this._subscribers[listenerGUID].listeners.push(newDataCallback);
      };

      Datafeed.DataPulseUpdater.prototype.unsubscribeDataListener = function (
        listenerGUID,
      ) {
        this._datafeed._logMessage("Unsubscribing " + listenerGUID);
        delete this._subscribers[listenerGUID];
      };

      Datafeed.Container = function (datafeedURL, updateFrequency) {
        this._datafeedURL = datafeedURL;
        this._configuration = {
          supports_search: false,
          supports_group_request: false,
          supported_resolutions: [
            "1",
            "5",
            "15",
            "30",
            "60",
            "120",
            "240",
            "D",
            "W",
            "M",
          ],
          supports_marks: true,
          supports_timescale_marks: true,
          // exchanges: ['myExchange']
        };

        this._barsPulseUpdater = new Datafeed.DataPulseUpdater(
          this,
          updateFrequency || 10 * 1000,
        );
        // this._quotesPulseUpdater = new Datafeed.QuotesPulseUpdater(this);

        this._enableLogging = false;
        this._callbacks = {};

        this._initializationFinished = true;
        this._fireEvent("initialized");
        this._fireEvent("configuration_ready");
      };

      Datafeed.Container.prototype._fireEvent = function (event, argument) {
        if (this._callbacks.hasOwnProperty(event)) {
          let callbacksChain = this._callbacks[event];
          for (let i = 0; i < callbacksChain.length; ++i) {
            callbacksChain[i](argument);
          }
          this._callbacks[event] = [];
        }
      };

      Datafeed.Container.prototype._logMessage = function (message) {
        if (this._enableLogging) {
          let now = new Date();
          //console.log("CHART LOGS: "+now.toLocaleTimeString() + '.' + now.getMilliseconds() + '> ' + message);
        }
      };

      Datafeed.Container.prototype.on = function (event, callback) {
        if (!this._callbacks.hasOwnProperty(event)) {
          this._callbacks[event] = [];
        }

        this._callbacks[event].push(callback);
        return this;
      };

      Datafeed.Container.prototype.onReady = function (callback) {
        let that = this;
        if (this._configuration) {
          setTimeout(function () {
            callback(that._configuration);
          }, 0);
        } else {
          this.on("configuration_ready", function () {
            callback(that._configuration);
          });
        }
      };

      Datafeed.Container.prototype.resolveSymbol = function (
        symbolName,
        onSymbolResolvedCallback,
        onResolveErrorCallback,
      ) {
        this._logMessage("GOWNO :: resolve symbol " + symbolName);
        Promise.resolve().then(() => {
          function adjustScale() {
            //精度 10的精度次方
            return Math.pow(10, this_vue.price_precision);
          }

          this._logMessage("GOWNO :: onResultReady inject " + symbolName);
          onSymbolResolvedCallback({
            name: symbolName.split("_")[1] + "/" + symbolName.split("_")[0],
            pricescale: adjustScale(),
            minmov: 1,
            minmov2: 0,
            ticker: symbolName,
            timezone: "Asia/Shanghai",
            session: "24x7",
            description: "",
            has_intraday: true,
            intraday_multipliers: ["1", "5", "15", "30", "60", "D", "W"], //It is an array containing intraday resolutions (in minutes) the datafeed wants to build by itself. E.g., if the datafeed reported he supports resolutions ["1", "5", "15"], but in fact it has only 1 minute bars for symbol X, it should set intraday_multipliers of X = [1]. This will make Charting Library to build 5 and 15 resolutions by itself.
            has_weekly_and_monthly: true,
            has_no_volume: false,
          });
        });
      };

      Datafeed.Container.prototype.getBars = function (
        symbolInfo,
        resolution,
        rangeStartDate,
        rangeEndDate,
        onDataCallback,
        onErrorCallback,
      ) {
        if (rangeStartDate > 0 && (rangeStartDate + "").length > 10) {
          throw new Error([
            "Got a JS time instead of Unix one.",
            rangeStartDate,
            rangeEndDate,
          ]);
        }
        this._send(this._datafeedURL, {
          b: rangeStartDate,
          endTime: rangeEndDate,
          s:
            symbolInfo.ticker.split("_")[0].toUpperCase() +
            "-" +
            symbolInfo.ticker.split("_")[1].toUpperCase(),
          p: formartResolution(resolution),
        })
          .then(function (response) {
            let tmp = [];
            tmp = response.data.data || [];
            // //console.log(tmp);
            let o = [];
            let h = [];
            let l = [];
            let c = [];
            let t = [];
            let v = [];

            for (let i = 0; i < tmp.length; i++) {
              o.push(tmp[i][1]);
              h.push(tmp[i][2]);
              l.push(tmp[i][3]);
              c.push(tmp[i][4]);
              t.push(tmp[i][0]);
              v.push(tmp[i][5]);
            }

            let data = {
              o,
              h,
              l,
              c,
              t,
              v,
            };

            let range = formartResolution(resolution);
            //若上次数据的最后一条数据的时间等于本次数据最后一条的时间，且两次的区间相同，并且收盘价没有变化，则视为no_data，为的是避免k线图往后拉之后无线刷新
            ////console.log(_lastTime + '--' + tmp[tmp.length-1][0] + '//' + _lastRange + '--' + range)
            if (
              (t.length > 0 &&
                (_lastTime === null || _lastTime !== tmp[tmp.length - 1][0])) ||
              range !== _lastRange ||
              _lastClose === null ||
              _lastClose !== tmp[tmp.length - 1][4]
            ) {
              // //console.log('ok')
              data.s = "ok";
            } else {
              // //console.log('no')
              data.s = "no_data";
            }

            if (tmp.length > 0) {
              _lastTime = tmp[tmp.length - 1][0];
              _lastClose = tmp[tmp.length - 1][4];
            } else {
              _lastTime = null;
            }

            _lastRange = range;

            let nodata = data.s === "no_data";

            if (data.s !== "ok" && !nodata) {
              if (!!onErrorCallback) {
                onErrorCallback(data.s);
              }

              return;
            }

            let bars = [];

            //  data is JSON having format {s: "status" (ok, no_data, error),
            //  v: [volumes], t: [times], o: [opens], h: [highs], l: [lows], c:[closes], nb: "optional_unixtime_if_no_data"}
            let barsCount = nodata ? 0 : data.t.length;

            let volumePresent = typeof data.v != "undefined";
            let ohlPresent = typeof data.o != "undefined";

            for (let i = 0; i < barsCount; ++i) {
              let barValue = {
                time: data.t[i],
                close: +data.c[i],
              };

              if (ohlPresent) {
                barValue.open = +data.o[i];
                barValue.high = +data.h[i];
                barValue.low = +data.l[i];
              } else {
                barValue.open = barValue.high = barValue.low = +barValue.close;
              }

              if (volumePresent) {
                barValue.volume = +data.v[i];
              }

              bars.push(barValue);
            }
            onDataCallback(bars, {
              noData: nodata,
              nextTime: data.nb || data.nextTime,
            });
          })
          .catch(function (arg) {
            if (!!onErrorCallback) {
              onErrorCallback("network error: " + JSON.stringify(arg));
            }
          });

        function formartResolution(val) {
          if (val) {
            if (val == "D") {
              return "1D";
            } else if (val == "W") {
              return "1W";
            } else if (val == "M") {
              return "1Month";
            } else {
              return val + "m";
            }
          } else {
            return "1m";
          }
        }
      };

      Datafeed.Container.prototype._send = function (url, params) {
        let request = url;
        if (params) {
          for (let i = 0; i < Object.keys(params).length; ++i) {
            let key = Object.keys(params)[i];
            let value = encodeURIComponent(params[key]);
            request += (i === 0 ? "?" : "&") + key + "=" + value;
          }
        }

        this._logMessage("New request: " + request);

        return this_vue.$axios.get(request, {});
      };

      Datafeed.Container.prototype.subscribeBars = function (
        symbolInfo,
        resolution,
        onRealtimeCallback,
        listenerGUID,
        onResetCacheNeededCallback,
      ) {
        //轮询监听，更新k线图
        this._barsPulseUpdater.subscribeDataListener(
          symbolInfo,
          resolution,
          onRealtimeCallback,
          listenerGUID,
          onResetCacheNeededCallback,
        );
      };

      Datafeed.Container.prototype.unsubscribeBars = function (listenerGUID) {
        this._barsPulseUpdater.unsubscribeDataListener(listenerGUID);
      };

      return new Datafeed.Container(datafeedURL, updateFrequency);
    },
  },
  computed: {
    ...mapState({
      appLan: "appLan",
    }),
  },
  watch: {
    symbol() {
      // ;
      // this.widget.chart().setChartType(1);
      this.widget.setSymbol(this.symbol, this.timeType);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/scss">
.comp-super-kline {
  background-color: #272b41;
  height: 100%;
}

.kline-loading {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #272b41;
  .comp-loading {
    padding-top: 0px;
  }
}
#tv_chart_container {
  height: 100%;
}
</style>
